import React, { useState } from "react";

const OurTechnology = () => {
  const primaryColor = "#FF8000";

  // Default category: frontend
  const [activeCategory, setActiveCategory] = useState("frontend");
  const categories = {
    backend: "BACKEND",
    frontend: "FRONTEND",
    mobile: "MOBILE",
    database: "DATABASE",
    testing: "TESTING TOOLS",
    devops: "DEVOPS",
    "full-stack": "FULL STACK",
    ads: "ADS", // ✅ new category
    motion: "MOTION GRAPHICS", // ✅ new category
  };
  
  const techItems = [
    { category: "backend", src: "/assets/Images/node js logo.png", alt: "Node Js" },
    { category: "backend", src: "/assets/Images/express.svg", alt: "Express" },
    { category: "backend full-stack", src: "/assets/Images/next.be0601bc3b634822be11.png", alt: "Next JS", width: "100px" },
    { category: "frontend", src: "/assets/Images/surface1.png", alt: "Surface" },
    { category: "frontend full-stack", src: "/assets/Images/bootstrap.svg", alt: "Bootstrap" },
    { category: "frontend", src: "/assets/Images/html-5-logo-svgrepo-com.png", alt: "HTML" },
    { category: "frontend", src: "/assets/Images/css-3-logo-svgrepo-com.png", alt: "CSS" },
    { category: "frontend full-stack", src: "/assets/Images/react-2.png", alt: "React" },
    { category: "frontend", src: "/assets/Images/java.ffdc9222837507fab7c6653646af4b48 1.png", alt: "Java" },
    { category: "frontend full-stack", src: "/assets/Images/node js logo.png", alt: "Node Js" },
    { category: "frontend", src: "/assets/Images/Vector.png", alt: "Vector" },
    { category: "mobile", src: "/assets/Images/android.svg", alt: "Android" },
    { category: "mobile", src: "/assets/Images/ios.svg", alt: "IOS" },
    { category: "mobile", src: "/assets/Images/flutter.svg", alt: "Flutter" },
    { category: "mobile", src: "/assets/Images/kotline.svg", alt: "Kotlin" },
    { category: "database", src: "/assets/Images/mysql.svg", alt: "MySQL" },
    { category: "database", src: "/assets/Images/microsoftSql.svg", alt: "SQL Server" },
    { category: "database", src: "/assets/Images/mongodb.svg", alt: "MongoDB" },
    { category: "database", src: "/assets/Images/firebase.svg", alt: "Firebase" },
    { category: "testing", src: "/assets/Images/postman.svg", alt: "Postman" },
    { category: "devops", src: "/assets/Images/github.svg", alt: "GitHub" },
    { category: "full-stack", src: "/assets/Images/mern.svg", alt: "MERN" },
    
    // ✅ Ads category
    { category: "ads", src: "/assets/Images/ps.png", alt: "Photoshop" },
    { category: "ads", src: "/assets/Images/illustrator.png", alt: "Illustrator" },
  
    // ✅ Motion Graphics category
    { category: "motion", src: "/assets/Images/adobe.png", alt: "Adobe Premiere Pro" },
    { category: "motion", src: "/assets/Images/ps.png", alt: "Photoshop" },
  ];
  
  return (
    <div className="tech-section padding-container">
      <div className="page-wrapper">
        <div className="tech">
          <div className="tech-text">
            <h1>
              OUR <span className="orange-text">TECHNOLOGIES</span>
            </h1>
            <p>
              VisionBird leverages cutting-edge technologies to deliver robust, scalable, and future-oriented custom software solutions.
            </p>
          </div>
        </div>

        {/* Toggle Buttons */}
        <div className="tech-languages">
          <div className="tech-type" id="tech-type">
            {Object.entries(categories).map(([key, label]) => (
              <button
                key={key}
                className="toggle-btn"
                style={{
                  background: activeCategory === key ? primaryColor : "transparent",
                }}
                onClick={() => setActiveCategory(key)}
              >
                <span>{label}</span>
              </button>
            ))}
          </div>

          {/* Filtered Tech Images */}
          <div className="Grid-3-tech">
            {techItems
              .filter((item) => item.category.includes(activeCategory))
              .map((item, idx) => (
                <div className={`tech-image ${item.category}`} key={idx}>
                  <img src={item.src} alt={item.alt} width={item.width || "auto"} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTechnology;
